import React from "react";

const Error = () => {
  return <div className="py-20 text-center">An error occured, try reload</div>;
};

export default Error;
